// frontend/src/services/postService.js
import axiosInstance from "../axiosConfig";

// Detectar automáticamente el entorno
const isProduction = window.location.hostname !== 'localhost';
const API_BASE_URL = isProduction ? 'https://brechovizinho.com.br' : 'http://localhost:8000';

console.log('🌍 API_BASE_URL:', API_BASE_URL);

const postService = {
  // Helper para procesar URLs de fotos
  processFotos: (fotos) => {
    if (!fotos) return [];
    
    if (Array.isArray(fotos)) {
      return fotos.map(foto => {
        if (foto && foto.startsWith('https://')) {
          return foto;
        }
        if (foto && !foto.startsWith('http') || foto.includes('localhost')) {
          let cleanFoto = foto.replace('http://localhost:8000', '');
          return API_BASE_URL + cleanFoto;
        }
        return foto;
      });
    }
    
    if (typeof fotos === 'string') {
      try {
        const parsed = JSON.parse(fotos);
        if (Array.isArray(parsed)) {
          return parsed.map(foto => {
            if (foto && foto.startsWith('https://')) {
              return foto;
            }
            if (foto && !foto.startsWith('http') || foto.includes('localhost')) {
              let cleanFoto = foto.replace('http://localhost:8000', '');
              return API_BASE_URL + cleanFoto;
            }
            return foto;
          });
        }
      } catch (e) {
        if (fotos && !fotos.startsWith('http') || fotos.includes('localhost')) {
          let cleanFoto = fotos.replace('http://localhost:8000', '');
          return [API_BASE_URL + cleanFoto];
        }
        return [fotos];
      }
    }
    
    return [];
  },

  // Obtener todos los posts con filtros
  getPosts: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.category && filters.category !== "") {
        params.append("category", filters.category);
      }
      if (filters.condominio && filters.condominio !== "" && filters.condominio !== "todos") {
        params.append("condominio", filters.condominio);
      }
      if (filters.tipo && filters.tipo !== "") {
        params.append("tipo", filters.tipo);
      }

      const url = `/posts${params.toString() ? `?${params.toString()}` : ""}`;
      const response = await axiosInstance.get(url);

      let posts = response.data;

      if (Array.isArray(posts)) {
        posts = posts.map((post) => ({
          ...post,
          fotos: postService.processFotos(post.fotos),
          condominio: post.condominio || null,
          user: post.user || null,
        }));
      }

      console.log("Posts procesados:", posts);

      return { success: true, data: posts };
    } catch (error) {
      console.error("Error fetching posts:", error);
      return {
        success: false,
        data: [],
        error: error.response?.data?.message || "Erro ao carregar produtos",
      };
    }
  },

  getPost: async (identifier) => {
    try {
      const response = await axiosInstance.get(`/posts/${identifier}`);
      const post = response.data;

      post.fotos = postService.processFotos(post.fotos);

      console.log("Post detail:", post);

      return { success: true, data: post };
    } catch (error) {
      console.error("Error fetching post:", error);
      return {
        success: false,
        data: null,
        error: error.response?.data?.message || "Erro ao carregar produto",
      };
    }
  },

  getUserPosts: async () => {
    try {
      const response = await axiosInstance.get("/user/posts");
      let posts = response.data;

      if (Array.isArray(posts)) {
        posts = posts.map((post) => ({
          ...post,
          fotos: postService.processFotos(post.fotos),
          foto: postService.processFotos(post.fotos)[0] || null,
        }));
      }

      return { success: true, data: posts };
    } catch (error) {
      console.error("Error fetching user posts:", error);
      return {
        success: false,
        data: [],
        error: error.response?.data?.message || "Erro ao carregar seus anúncios",
      };
    }
  },

  createPost: async (formData) => {
    try {
      const response = await axiosInstance.post("/posts", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error creating post:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao criar anúncio",
      };
    }
  },

  updatePost: async (id, formData) => {
    try {
      const response = await axiosInstance.post(`/posts/${id}?_method=PUT`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error updating post:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar anúncio",
      };
    }
  },

  markAsSold: async (id) => {
    try {
      const response = await axiosInstance.put(`/posts/${id}/mark-as-sold`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error marking post as sold:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao marcar como vendido",
      };
    }
  },

  toggleActive: async (id) => {
    try {
      const response = await axiosInstance.put(`/posts/${id}/toggle-active`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error toggling post active status:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao alterar disponibilidade do anúncio",
      };
    }
  },

  deletePost: async (id) => {
    try {
      const response = await axiosInstance.delete(`/posts/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error deleting post:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao excluir produto",
      };
    }
  },

  // 🔥 NUEVO: Obtener estadísticas de publicaciones de la unidad
  getPublicationStats: async () => {
    try {
      const response = await axiosInstance.get('/user/publication-stats');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching publication stats:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao carregar estatísticas de publicações',
      };
    }
  },
};

export default postService;